// extracted by mini-css-extract-plugin
export default {"container":"TopicView-module__container--yjAoq","isEditing":"TopicView-module__isEditing--7HuqD","animatedBackground":"TopicView-module__animatedBackground--+20oZ"};